import { useEffect } from 'react'

const SITE_NAME = 'Session Loops'
const BASE_URL = 'https://sessionloops.com'
const DEFAULT_TITLE = 'Session Loops - AI-Powered Music Production Tools'
const DEFAULT_DESC = 'Create professional-quality music with AI: PitchNet (free vocal tuning), VocalNet (voice transformation), DrumNet (drum generation), and royalty-free sample packs.'

function setMeta(selector, attr, value) {
  const el = document.querySelector(selector)
  if (el) el.setAttribute(attr, value)
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function useTitle(title, description, canonicalPath) {
  useEffect(() => {
    const pageTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE
    const pageDesc = description || DEFAULT_DESC
    const canonicalUrl = canonicalPath ? `${BASE_URL}${canonicalPath}` : BASE_URL

    document.title = pageTitle
    setMeta('meta[name="description"]', 'content', pageDesc)
    setMeta('meta[property="og:title"]', 'content', pageTitle)
    setMeta('meta[property="og:description"]', 'content', pageDesc)
    setMeta('meta[property="og:url"]', 'content', canonicalUrl)
    setMeta('meta[name="twitter:title"]', 'content', pageTitle)
    setMeta('meta[name="twitter:description"]', 'content', pageDesc)
    setCanonical(canonicalUrl)

    return () => {
      document.title = DEFAULT_TITLE
      setMeta('meta[name="description"]', 'content', DEFAULT_DESC)
      setMeta('meta[property="og:title"]', 'content', DEFAULT_TITLE)
      setMeta('meta[property="og:description"]', 'content', DEFAULT_DESC)
      setMeta('meta[property="og:url"]', 'content', BASE_URL)
      setMeta('meta[name="twitter:title"]', 'content', DEFAULT_TITLE)
      setMeta('meta[name="twitter:description"]', 'content', DEFAULT_DESC)
      setCanonical(BASE_URL)
    }
  }, [title, description, canonicalPath])
}

export default useTitle
